// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var AccountingExportSettingsController = function ($rootScope, $scope, $filter, AccountingExportSettings, gettextCatalog, gettext, ProductInfo, CountryList, WriteOff) {
    const supportedLanguages = ["en", "de"];   
    const numberOfRowsinList = 5;       
    const RevenueAccountType = Object.freeze({
        'ProductBased':'ProductBased',
        'TaxBased':'TaxBased',
    });

    const AccountExportProductType = Object.freeze({
        'RecurringComponent' : 'RecurringComponent',
        'Plan' : 'Plan',
        'PrepaidCard' : 'PrepaidCard',
        'Discount' : 'Discount',
        'NoProduct' : 'NoProduct',
        'MeteredUsageComponent' : 'MeteredUsageComponent',
    });

    const AccountType = Object.freeze({
        'Gross':'Gross',
        'Net':'Net',
        'NoTax':'NoTax',
    });
    
    $scope.searchFilter = '';
    $scope.supportedLanguages = $rootScope.getLanguages().filter(language => supportedLanguages.includes(language.key));

    $scope.showFilter = Object.freeze({
        'Valid':'Valid',
        'Invalid':'Invalid',
        'Changed':'Changed',
        'Unchanged':'Unchanged'
    });
    $scope.isProductBasedAccountsTabShown = false;

    $scope.accountingFormat = Object.freeze({
        "Sap": "Sap",
        "Datev": "Datev",
        "Pons": "Pons"
    });
    
    var currentLocale = gettextCatalog.currentLanguage.toUpperCase();
    var countries = [];
    let hasWriteOffs = false;

    WriteOff.get(1).then(function (response) {
        hasWriteOffs = response.data.length > 0;
    });
    
    CountryList.getCountries().then(function (response) {
         countries = response.data;
    });
    
    $scope.ponsFeatureFlagName = "Pons";
    $scope.fiscalYearTooltipText = gettextCatalog.getString(gettext("The month of use. By default, January is used as the beginning of the year."));
    $scope.glAccountNumberLengthTooltipText = gettextCatalog.getString(
        gettext('Please note: In Datev it is not possible to decrease the length of the field "G/L Account length" after it has been increased.')) +
        '<a href="https://apps.datev.de/dnlexka/document/1000104" target="_blank">' + gettextCatalog.getString(gettext('Read more.')) + '</a>';
    $scope.DirectlyAssignPaymentsTooltip = _txt('Directly assign payments leads to payment postings outputting which invoice they are meant to pay for. This information is captured at the point in time where the payment was triggered. Once the option is activated all existing payment postings that were exported without assignments will be corrected. More information in ')  +
        '<a href="https://docu.billwerk.plus/help/transform_en/en/activities-and-data-exports/accounting-export.html" target="_blank">' + _txt('Help Center') + '</a>.';

    $scope.productInfo = ProductInfo.get();
    
    $scope.settings = AccountingExportSettings.get();

    $scope.productSettingsAccountsRaw = {};
    $scope.productSettingsAccounts = {};


    AccountingExportSettings.getProductBasedAccounts(
        {}, function (data) {
            $scope.productSettingsAccountsRaw = data.data;            
            if (!$scope.productSettingsAccountsRaw) return;
            
            var productByTypes = arrayGroupBy($scope.productSettingsAccountsRaw, 'ProductType');
            Object.keys(productByTypes).forEach((key, idx, arr) => {
                $scope.productSettingsAccounts[key] = {
                    type: key,
                    items: productByTypes[key],
                    paginator: $scope.getPaginator(productByTypes[key])
                }
            });
    });
      
    $scope.getPaginator = function (allItems) {
        return $scope.clientPaginator(allItems, numberOfRowsinList, filterItems, (obj)=>{return obj.ProductId;});
    }
    
    function filterValidation(prodItem){
        if (!$scope.validationFilter) return true;
        var isModified = $scope.modifiedProducts[prodItem.ProductId];
        if ($scope.validationFilter === $scope.showFilter.Changed) 
            return !!isModified;
        if ($scope.validationFilter === $scope.showFilter.Unchanged)
            return !isModified;
        var isValid = validateProduct(prodItem);

         return $scope.validationFilter === $scope.showFilter.Valid && isValid 
             || $scope.validationFilter === $scope.showFilter.Invalid && !isValid;
    }
    
    function filterItems(allModels, searchInput) {
        var hasFilter = !!(searchInput && searchInput.length > 0); 
        var result = allModels.filter(x =>
            hasFilter && x.ProductName && x.ProductName.toLowerCase().indexOf(searchInput.toLowerCase()) >= 0 && filterValidation(x)
            ||!hasFilter && filterValidation(x));
        return result;
    }

    function arrayGroupBy(xs, key) {
        return xs.reduce(function(rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }
    
    $scope.getProductByTypes = () => $scope.productSettingsAccounts 
            ? Object.values($scope.productSettingsAccounts)
            : undefined;
    
    $scope.modifiedProducts = {};
    $scope.getModified = function(type) {

        return type ? Object.values($scope.modifiedProducts).filter(x=>x.productType === type || !type)
                    : Object.values($scope.modifiedProducts);
    };
    
    $scope.getModifiedCount = (type) => $scope.getModified(type).length;

    $scope.addModified = function(type, prodId, rowId, model) {

        var productItems = $scope.modifiedProducts[prodId];
        if (!productItems)
            $scope.modifiedProducts[prodId] = productItems = { id:prodId, productType : type, rowModels: {}};        

        if (!productItems.rowModels[rowId])
            productItems.rowModels[rowId] = model;
    };
    
    $scope.deleteModified = function(prodId, colId) {
        var productItems = $scope.modifiedProducts[prodId];
        if (productItems && productItems.rowModels[colId]) {
            delete productItems.rowModels[colId];
            if (Object.keys(productItems.rowModels).length === 0)
                delete $scope.modifiedProducts[prodId];
        }
    };
    
    $scope.resetModified = (type) => $scope.actAndRemoveModified(type,(model)=> model.resetCallback());
   
    $scope.clearModified = (type) => $scope.actAndRemoveModified(type);    
  
    $scope.actAndRemoveModified = function(type, actCallback) {
        Object.keys($scope.modifiedProducts).forEach(function (prodId, index, array){
            var val = $scope.modifiedProducts[prodId];
            if (!type || val.productType === type) {
                if (actCallback)Object.values(val.rowModels).forEach(model=> actCallback(model));
                delete $scope.modifiedProducts[prodId];
            }
        });
    };
    
    function getModelValue(model, modelName) {
        var modelPath = modelName.split('.');
        for (let i = 0; i < modelPath.length; i++) {
            model = model[modelPath[i]];
        }
        return model;
    }
    
    function setModelValue(model, modelName, value) {
        var modelPath = modelName.split('.');
        for (let i = 0; i < modelPath.length - 1; i++) {
            model = model[modelPath[i]];
        }
        model[modelPath[modelPath.length - 1]] = value;
    }
    
    function getRowId(model, modelName) {
        return (model.item && model.item.ProductId) ? model.item.ProductId : modelName;
    }
    
    function getRowType(model) {
        return (model.item && model.item.ProductType) ? model.item.ProductType : "";
    }

    $scope.isModified = function(name) {
        return !!$scope.getModifiedModel(this, name);
    };
    
    $scope.getModifiedModel = function(scope, name) {
        var id = getRowId(scope, name);
        if (!id) return false;
        var prods = $scope.modifiedProducts[id];
        return prods && prods.rowModels && prods.rowModels[name];
    };
   
    $scope.accountChanged = function (modelName, oldValue) {
        var self = this;        
        var newValue = getModelValue(self, modelName);
        var rowId = getRowId(self, modelName);
        var rowType = getRowType(self);
                  
        var model = $scope.getModifiedModel(self, modelName);
        var originalVal = model && model.originalValue;

        if (newValue !== originalVal || !newValue && newValue !== oldValue) {
            if (!model) {
                model = {
                    parent: self, 
                    originalValue: oldValue,
                    resetCallback : () => {
                        var setVal = (model.originalValue) ? model.originalValue : "";
                        setModelValue(self, modelName, setVal);
                    }
                };
                $scope.addModified(rowType, rowId, modelName, model);
            }
        }
        else {
            $scope.deleteModified(rowId, modelName);
        }        
    };

    function validateFieldValue (val) { 
        return !!(val && val.trim().length > 0);
    }

    function validateAccounts (accounts,showWriteOff) {
        return !!accounts && (validateFieldValue(accounts.RevenueFeeAccount) && showWriteOff && validateFieldValue(accounts.WriteOffFeeAccount)
            || !showWriteOff && validateFieldValue(accounts.RevenueFeeAccount));
    }

    function validateSections()
    {
        var errors = [];
        $scope.getProductByTypes().forEach(item => {
            var checkRecurring = (item.type === AccountExportProductType.Plan || item.type === AccountExportProductType.RecurringComponent);
            var checkOneTime = (item.type === AccountExportProductType.Plan || item.type === AccountExportProductType.Discount || item.type === AccountExportProductType.NoProduct || item.type === AccountExportProductType.MeteredUsageComponent);
            var checkGenericWithoutWriteOff = (item.type === AccountExportProductType.PrepaidCard);
    
            if (checkRecurring && item.items.some(x => x.Recurring?.RevenueFeeAccount == null || hasWriteOffs && x.Recurring?.WriteOffFeeAccount == null)
                || checkOneTime && item.items.some(x => x.OneTime?.RevenueFeeAccount == null || hasWriteOffs && x.OneTime?.WriteOffFeeAccount == null)
                || checkGenericWithoutWriteOff && item.items.some(x => x.OneTime?.RevenueFeeAccount == null))
                {
                    errors.push(_txt($scope.getSectionName(item.type)));
                }  
        });
        
        return errors.join(', '); 
    }
    
    function validateProduct(item) {        
        const showWriteOff = $scope.isWriteOffVisible();
        return (item.ProductType === AccountExportProductType.Plan && validateAccounts(item.OneTime, showWriteOff)
                    && validateAccounts(item.Recurring, showWriteOff))
            || (item.ProductType === AccountExportProductType.RecurringComponent && validateAccounts(item.Recurring, showWriteOff))
            || (item.ProductType === AccountExportProductType.Discount && validateAccounts(item.OneTime, showWriteOff))
            || (item.ProductType === AccountExportProductType.PrepaidCard && validateAccounts(item.OneTime, false)) //as Prepaid Cards cannot have write-offs
            || (item.ProductType === AccountExportProductType.NoProduct && validateAccounts(item.OneTime, showWriteOff))
            || (item.ProductType === AccountExportProductType.MeteredUsageComponent && validateAccounts(item.OneTime, showWriteOff)); 
    }    
    
    $scope.save = function () {
        const save = function () {
            if ($scope.isSelectedAccountingFormat($scope.accountingFormat.Pons) && !$scope.features[$scope.ponsFeatureFlagName]) {
                $scope.notifyCustomError(_txt("Restricted feature. Please contact Support."));
                return;
            }
            
            if (!$scope.isSelectedAccountingFormat($scope.accountingFormat.Datev) && $scope.settings.AssignmentSettings && $scope.settings.AssignmentSettings.DirectlyAssignPayments)
                $scope.settings.AssignmentSettings.DirectlyAssignPayments = false;

            if (!$scope.settings.IncludeDeferrals || !$scope.settings.PostingPerLineItem)
                $scope.settings.PostingPerLineItemForDeferrals = false;
            
            $scope.settings.$update({}, function (data) {
                if($scope.settings.RevenueAccountType === RevenueAccountType.ProductBased)                
                    $scope.saveProductPartially(null, true);
                else
                    $scope.notifySuccess();
            })
        };

        $scope.yesCancel(
            _txt('Change Account Settings'),
            _txt('Do you want to change the accounting export settings? This may lead to a lot of adjustment postings.'), 
            save
        );
    }

    $scope.isWriteOffVisible = ()=> 
        !!($scope.productSettingsAccountsRaw && hasWriteOffs);
    
    $scope.saveProductPartially = function(type, isMessageShown) { // type is null in case of saving all blocks
        const save = function() {
            if (!$scope.productSettingsAccountsRaw) return;
            const modified = $scope.getModified(type);
            const showNotifyAndValidationWarningIfRequired = ()=>{
                $scope.notifySuccess();
                if(!type)
                {
                    const errors = validateSections();
                    if(errors)
                    {
                        $scope.showWarningBox(_txt("Your accounting settings have been saved. However, not all product-based accounts have been configured. On the Product-based Accounts tab, please add data for the following sections") + ": " + errors);
                    }
                }                
            };
    
            if (!modified || modified.length === 0) 
            {
                showNotifyAndValidationWarningIfRequired();
                return;
            }

            const groupedMap = arrayGroupBy(modified, 'id');
            const prodAccounts = $scope.productSettingsAccountsRaw.filter(x=> !!groupedMap[x.ProductId]);
            
            AccountingExportSettings.saveProductBasedAccounts(
                prodAccounts,
                true, 
                function (data) {
                    $scope.clearModified(type);
                    showNotifyAndValidationWarningIfRequired();
            });
        };

        if(isMessageShown || validateSections()) // if at least 1 section is not valid, postings wouldn't be invalidated
        {
            save();
        }
        else
        {
            $scope.yesCancel(
                _txt('Change Account Settings'),
                _txt('Do you want to change the accounting export settings? This may lead to a lot of adjustment postings.'), 
                save
            );
        }
    }; 
    
    $scope.isSelectedAccountingFormat = function(){
        let compareResult = false;
        for (let i = 0; i < arguments.length; i++) {
            if (arguments[i] === $scope.settings.Format){
                compareResult = true;
                break;
            }
        }
        return compareResult;
    };    

    $scope.getTextForKeyCountry = function(key){
        if(key){
            const fallbackCountryExists = key.FallbackCountry != null && key.FallbackCountry !== "";
            const countryName = getCountryName(key.Country, currentLocale);
            const keyCountryText = `${key.Country}, ${countryName}`
            if (fallbackCountryExists)
            {
                return `${keyCountryText} (${getFallbackText(key.FallbackCountry)})`;
            }
            return keyCountryText;
        }
        else {
            return '';
        } 
    };
    
    function getCountryName(code, locale) {
        if (countries.length === 0) return;
        
        const country = countries.filter(function(c) {
            return c.TwoLetterCode === code;
        })[0];
        return country[locale] ? country[locale] : country['EN'];
    }

    $scope.getVatPercentageLabel = function (key) {
        try {
            let primaryCategory = $scope.productInfo.TaxDefinitionById(key.TaxDefinitionId).PrimaryCategory;
            if (key.VatPercentage !== undefined || primaryCategory === 'Vat') {
                return ` ${key.VatPercentage}%`;
            }
        } catch (e) {
            return '';
        }
    };   

    $scope.getProductBasedAccountsTabShow = (revenueAccountType, format) => 
        revenueAccountType === RevenueAccountType.ProductBased && format !== $scope.accountingFormat.Pons;       

    $scope.isRegionalTaxAccountSectionShown = (groupingSettings, revenueAccountType, format, productBasedAccountType) =>        
        $scope.isRegionalTaxAccountFieldShown(revenueAccountType, format)
        || $scope.isRegionalTaxAccountNetFieldShown(groupingSettings, revenueAccountType, format, productBasedAccountType)
        || $scope.isRegionalTaxCodeFieldShown(format);

    $scope.isAccountTypeFieldForGroupsShown = (groupingSettings, revenueAccountType, format) =>
        format !== $scope.accountingFormat.Pons
        && groupingSettings && groupingSettings.AccountType !== AccountType.NoTax
        && revenueAccountType !== RevenueAccountType.ProductBased;    
    
    $scope.isRegionalTaxAccountFieldShown = (revenueAccountType, format)=>
        revenueAccountType !== RevenueAccountType.ProductBased &&
        format !== $scope.accountingFormat.Pons;
    
    $scope.isRegionalTaxAccountNetFieldShown = (groupingSettings, revenueAccountType, format, productBasedAccountType) =>
        format !== $scope.accountingFormat.Pons
        &&(revenueAccountType === RevenueAccountType.ProductBased && productBasedAccountType === AccountType.Net && groupingSettings.AccountType !== AccountType.NoTax
            || revenueAccountType === RevenueAccountType.TaxBased && groupingSettings && groupingSettings.AccountType === AccountType.Net
        );
    
    $scope.isRegionalTaxCodeFieldShown = (format) =>
        format === $scope.accountingFormat.Pons || format === $scope.accountingFormat.Sap;

    $scope.onFormatChange = function() {
        if ($scope.settings.Format === $scope.accountingFormat.Pons){
            $scope.settings.RevenueAccountType = RevenueAccountType.TaxBased;
        }
    };

    $scope.onRevenueAccountTypeChange = function() {
        if (!$scope.settings.ProductBasedSettings.AccountType)
            $scope.settings.ProductBasedSettings.AccountType = AccountType.Gross;
    };    
    
    $scope.isSaveBlockDisplayedOnTheProductBasedTab = () => $scope.adminOrInRole(['Finance']);    

    $scope.validationFilterChanged = function() {
        $scope.validationFilter = this.validationFilter;
        $scope.updateFilter();
    }
    
    $scope.updateFilter = function() {
        for(var i = 0; i < $scope.getProductByTypes().length; i++) {
            var paginator = $scope.getProductByTypes()[i].paginator;
            paginator.filter($scope.searchFilter);
        }
    }

    $scope.onSeachChange = function() {
        $scope.searchFilter = this.searchFilter;
    }

    $scope.clearFilter = function() {
        this.searchFilter = '';
        this.$parent.$parent.searchFilter = '';
        $scope.updateFilter();
    }

    function getFallbackText(countryFallbackCode) {
        switch (countryFallbackCode) {
            case "XX" :
                return "Fallback World";
            case "EU" :
                return "Fallback EU";
            case "GB":
                return "Fallback GB";
        }
    }

    $scope.getSectionName = function(productType) {
        
        switch (productType) {
            case AccountExportProductType.Plan:
                return _txt("Plans");
            case AccountExportProductType.RecurringComponent:
                return _txt("Components");
            case AccountExportProductType.Discount:
                return _txt("Discounts");
            case AccountExportProductType.PrepaidCard:
                return _txt("Prepaid Cards");
            case AccountExportProductType.NoProduct:
                return _txt("Without Product");
            case AccountExportProductType.MeteredUsageComponent:
                return _txt("Metered Usage Components");
            default:
                return "";
        }
    }

    $scope.isColumnVisible = function(productType, index) {

        if(index === 0 || index === 2) //revenue recurring || write-off recurring
            return productType === AccountExportProductType.Plan || productType === AccountExportProductType.RecurringComponent;

        if(index === 1) //revenue one-time
            return productType !== AccountExportProductType.RecurringComponent;

        if(index === 3) //write-off one-time
            return productType !== AccountExportProductType.RecurringComponent && productType !== AccountExportProductType.PrepaidCard;

        return false;
    }

    $scope.getColumnName = function(productType, index) {

        if(index === 0) //revenue recurring
             return  _txt("Revenue Recurring");      

        if(index === 1) //revenue one-time
            return productType === AccountExportProductType.Plan ?  _txt("Revenue Setup") : _txt("Revenue");

        if(index === 2) //write-off recurring
            return _txt("Write-Off Recurring");

        if(index === 3) //write-off one-time
            return productType === AccountExportProductType.Plan ?  _txt("Write-Off Setup") : _txt("Write-Off");

        return "";
    }
    
    function _txt(msg) {
        return gettextCatalog.getString(gettext(msg));
    }
    
};
AccountingExportSettingsController.$inject = ['$rootScope', '$scope','$filter' ,'AccountingExportSettings', 'gettextCatalog', 'gettext', 'ProductInfo', 'CountryList', 'WriteOff'];
